<template>
  <div class="d-flex">
    <p-input-text
      v-if="withText"
      :value="hex"
      size="small"
      @updated="emitUpdate($event)"
    />
    <input
      type="color"
      :value="hex"
      class="rounded bg-white"
      :class="{
        'ml-2 flex-shrink-0': withText
      }"
      @change="emitUpdate($event)"
    />
  </div>
</template>

<script setup>
const props = defineProps({
  modelValue: {
    type: String,
    default: null
  },
  withText: {
    type: Boolean,
    default: false
  },
  noHash: {
    // the model value is coming in as 000000 instead of #000000
    type: Boolean,
    default: false
  }
})
const emit = defineEmits(['update:modelValue'])

const hex = computed(() => {
  if (props.noHash && props.modelValue) {
    if (props.modelValue && props.modelValue.charAt(0) !== '#') {
      return '#' + props.modelValue
    }
  }
  return props.modelValue
})

const emitUpdate = ($event) => {
  let value = $event.target?.value

  if (props.noHash && value.includes('#')) {
    value = value.replace('#', '')
  }

  emit('update:modelValue', value)
}
</script>

<style scoped>
input[type='color'] {
  border: 1px solid var(--p-inputtext-border-color);
  height: 33px;
}
</style>
